// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonUndo_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.273 11.6273C15.4826 9.01748 14.2125 6.39622 11.7942 5.00003C8.44618 3.06703 4.16505 4.21416 2.23205 7.5622L0.5 6.5622L1.09808 11.5263L5.69615 9.5622L3.9641 8.5622C5.34481 6.17074 8.40277 5.35137 10.7942 6.73208C12.2109 7.54999 13.0759 8.95647 13.2586 10.4643L15.273 11.6273Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M20.7071 14.11C20.1081 12.3269 18.8814 10.7466 17.1244 9.73216C13.298 7.52302 8.40529 8.83402 6.19615 12.6604L9.66025 14.6604L2.33013 17.3565L1 9.66036L4.4641 11.6604C7.22553 6.87743 13.3414 5.23868 18.1244 8.00011C20.9577 9.63592 22.6877 12.4489 23.0532 15.4646L20.7071 14.11Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonUndo is a generated icon component.
 */
let IconCommonUndo = IconCommonUndo_1 = class IconCommonUndo extends IconBaseElement {
    render() {
        return html `${IconCommonUndo_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonUndo.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonUndo = IconCommonUndo_1 = __decorate([
    customElement('zui-icon-common-undo')
], IconCommonUndo);
export { IconCommonUndo };
